import React from 'react'
import Cocktails from './Cocktails'
import NaCocktails from './NaCocktails'

const CocktailLocationRouter = (props) => {
    let location = props.locationId
    console.log(props)
    if (location === 'pl2' || location === 'pl5'){
        return (
            <NaCocktails 
                dessertMenu={props.dessertMenu}
                happyHours={props.happyHours}
                mocktailMenu={props.cocktailMenu}
                locationId={props.locationId}
                location={props.location}
            />
        )
    } else {
        return(
            <Cocktails 
               happyHours={props.happyHours}
               cocktailMenu={props.cocktailMenu}
               locationId={props.locationId}
               location={props.location}
              
            />
        )
    }
}
export default CocktailLocationRouter